import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { msalConfig } from './auth/msalConfig';
import './index.css';

const msalInstance = new PublicClientApplication(msalConfig);

const isTestEnvironment = import.meta.env.VITE_ENABLE_TEST_ROUTES === 'true';

const AppWithProviders = (
  <MsalProvider instance={msalInstance}>
    <App />
  </MsalProvider>
);

createRoot(document.getElementById('root')!).render(
  isTestEnvironment ? (
    AppWithProviders
  ) : (
    <StrictMode>{AppWithProviders}</StrictMode>
  ),
);
